/* BEGIN_COPYRIGHT_HEADER

Copyright Vspry International Limited (c) 2020
All rights reserved.

END_COPYRIGHT_HEADER */

import { ReactNode } from 'react'
import { FlexBox, Text, Tile } from 'vspry-style-components'
import HeadingText from './HeadingText'

type PrettyTileProps = {
    title?: string
    icon?: ReactNode
    titleRight?: ReactNode
    descriptions?: string[]
    children?: ReactNode
    fetching?: boolean
    smallGap?: boolean
}

export default function PrettyTile({ title, icon, titleRight, descriptions, children, fetching, smallGap }: PrettyTileProps) {
    return (
        <Tile $loading={fetching}>
            <FlexBox padding='large' $column gap={smallGap ? 'small' : 'medium'}>
                <div>
                    <FlexBox $align>
                        <HeadingText>
                            {title} {icon}
                        </HeadingText>

                        {titleRight}
                    </FlexBox>
                    {descriptions?.map((description) => (
                        <Text key={description} size='xSmall' $left margin='small'>
                            {description}
                        </Text>
                    ))}
                </div>
                {children}
            </FlexBox>
        </Tile>
    )
}
